import { Button } from 'components/buttons/Button/Button';
import Label from 'components/Label';
import TextWithIcon from 'components/TextWithIcon';

const HeroNewsCard = ({ card, array }) => {
    const moveSlideHeroNews = el => {
        const activeSlide = document.querySelector('.slider-head .swiper-slide-active');

        if (activeSlide) {
            activeSlide.classList.remove('swiper-slide-active');

            const targetSlide = document.querySelector(`.slider-head [data-swiper-slide-index="${el}"]`);

            if (targetSlide) {
                targetSlide.classList.add('swiper-slide-active');

                const swiper = document.querySelector('.slider-head').swiper;

                if (swiper) {
                    swiper.slideTo(el);
                }
            }
        }
    };

    return (
        <>
            <img className="news-wrapper-image" src={card.image} alt="plants" />
            <div className="news-box">
                <div>
                    <Label>NEWS</Label>
                    <p className="description-demibold">
                        <a href="/#">{card.article}</a>
                    </p>
                    <div className="news-time-data">
                        <TextWithIcon iconName="calendar" text={card.date} />
                        <TextWithIcon iconName="clock" text={`${card.read} MIN TO READ`} />
                    </div>
                </div>
                <div className="news-box-bottom">
                    <Button type="learn-more-arrow white-text">LEARN MORE</Button>
                    <div className="pagination-wrapper">
                        {array?.map((el, index) => (
                            <div
                                onClick={() => moveSlideHeroNews(index)}
                                key={el.article}
                                className={`pagination-dot ${card.article === el.article && 'active-dot'}`}
                            ></div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default HeroNewsCard;
